<template>
  <transition name="fade">
  <div class="base">
    <Scene
      id="guidelines"
      title="Guidelines"
      :media="[require('@/assets/audio/Guidelines.mp3')]"
      :trackPostTime="1*60+8"
      nextPath="trackchoice"
      :autoplay="false">
      <p>Before we start, let's make sure you're ready.</p>
      <ul class="guidelines">
        <li>Play the audio below to test sound.</li>
        <li>We will be touring your home; are you there?</li>
        <li>You'll be with us for 35-40 minutes.</li>
        <li>Follow instructions as well as you can.</li>
        <li>A mobile device and headphones are recommended.</li>
        <li>Clear your kitchen table.</li>
        <li>Multiple people can participate at the same time on different tracks.</li>        
      </ul>
      <p class="bottomspacer">Ready? Listen to the end and hit the "next" button to choose your track.</p>
    </Scene>
  </div>
  </transition>
</template>

<script>
import Scene from '@/components/Scene.vue'

export default {
  name: 'Guidelines',
  components: {
    Scene,
  },
  props: {
  },
  data () {
    return {
    }
  },
  methods: {
  }
}
</script>

<style scoped>
</style>